import { render, staticRenderFns } from "./InterestsCard.vue?vue&type=template&id=ec5b546a&"
import script from "./InterestsCard.vue?vue&type=script&lang=js&"
export * from "./InterestsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports